import React from 'react';

import { Helmet } from 'react-helmet';

import { Alert, Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BundleForm from './components/BundleForm';

function BundlesCreate() {
  return (
    <Container>
      <Helmet>
        <title>Create New Bundle</title>
      </Helmet>

      <PageHeader title="Create New Bundle" backButton="/cruises/bundles" />

      <Box mt={1}>
        <BundleForm />
      </Box>

      <Box mt={3}>
        <Alert severity="info">Save the bundle before managing items and filters</Alert>
      </Box>
    </Container>
  );
}

export default BundlesCreate;
